<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>
<ng-template #bodyTemplate>
  <div class="qb-list-actions">
    <span class="text-sm text-gray-700">
      One row per master rule from Utilities &gt; AI Guidelines. To change a rule for every program of this account,
      type in Account Override. A program can change it again on its own AI Guidelines tab.
    </span>
  </div>
  <div class="qb-layout-grid">
    <prox-ag-grid [gridOptions]="gridOptions" [rowData]="grid.rows"></prox-ag-grid>
  </div>
</ng-template>

<!-- EXCEPTION to Template 1's default Go Back footer: this list is edited in place, so it needs
     Save and Cancel, the same as Utilities > AI Guidelines. -->
<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" [isReadOnly]="isReadOnly()" (undo)="onUndo()" (save)="onSave()"
    (cancel)="onCancel()"></prox-save-cancel>
</ng-template>
